import { v4 as uuidv4 } from 'uuid'
import clsx from 'clsx'
import Pluralize from 'pluralize'
import SongwriterCatalogBuilderToggle from '@Components/SongwriterCatalogBuilderToggle'
import React from 'react'
import { SearchResultPartyDetails } from '@Entities/party-details'
import { observer } from 'mobx-react'
import numberOrZero from '@App/helpers/number-or-zero'

interface SongwriterCatalogBuilderRowProps {
    writer: SearchResultPartyDetails
    onTitleClick: (partyDetails: SearchResultPartyDetails) => void
    onWriterToggle: (isLinked: boolean, writerIpId: number) => void
    isChecked: boolean
}

const SongwriterCatalogBuilderRow = (props: SongwriterCatalogBuilderRowProps) => {
    const { writer, onTitleClick, onWriterToggle, isChecked } = props

    return (
        <tr key={writer.ipId ?? uuidv4()}>
            <td>
                <div className="writer-data">
                    <div className="writer-name-titles">
                        <span className="writer-name">{writer.name}:</span>
                        <span
                            className={clsx('writer-titles', !!writer.worksCount && 'clickable')}
                            onClick={() => !!writer.worksCount && onTitleClick(writer)}
                        >
                            {Pluralize('title', numberOrZero(writer.worksCount), true)}
                        </span>
                    </div>
                    <div className="writer-ipi">
                        <span>IPI:</span> {writer.ipiNumber}
                    </div>
                </div>
            </td>
            <td>
                <SongwriterCatalogBuilderToggle
                    onClick={(isLinked) => {
                        onWriterToggle(isLinked, Number(writer.ipId))
                    }}
                    label={isChecked ? 'In catalog' : 'Add to catalog'}
                    checked={isChecked}
                />
            </td>
        </tr>
    )
}

export default observer(SongwriterCatalogBuilderRow)
